import { render, staticRenderFns } from "./yijianbaoxiu.vue?vue&type=template&id=a302f556&"
import script from "./yijianbaoxiu.vue?vue&type=script&lang=js&"
export * from "./yijianbaoxiu.vue?vue&type=script&lang=js&"
import style0 from "./yijianbaoxiu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports